export default __webpack_public_path__ + "707b96e9d0a243e4d232005b7a27c379.png";